import React, { useState } from 'react';

const DefaultFormatActionableButton = ({ schema, ownData, ownProps = {} }) => {
  const { onClick = () => Promise.resolve() } = ownProps;
  const [isDisplayed, setisDisplayed] = useState(false);

  const handleCallback = async () => {
    setisDisplayed(!isDisplayed);
    try {
      await onClick({ data: ownData, schema });
    } catch {
      /* fail silently */
    }
  };

  return (
    <button
      className="default-format-actionable-button"
      onClick={handleCallback}
    >
      {isDisplayed ? <>Hide Data</> : <>Display Data</>}
    </button>
  );
};

export default DefaultFormatActionableButton;
